import type { ReactNode } from "react";

/**
 * One row rhythm for every section in the drawer: a fixed label column so the
 * labels form a single edge, a flexible value column, and a trailing column
 * that lines the copy buttons and durations up against the right margin.
 */
export const EVENT_DETAIL_ROW_GRID = "grid grid-cols-[7.5rem_minmax(0,1fr)_auto] items-baseline gap-x-4";

export const EVENT_SECTION_LABEL_CLASS =
  "text-[11px] uppercase tracking-wider text-muted-foreground";

export function EventDetailSection({
  label,
  aside,
  children,
}: {
  label: string;
  aside?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="flex flex-col gap-2">
      <div className="flex min-h-6 items-center justify-between gap-4">
        <h3 className={EVENT_SECTION_LABEL_CLASS}>{label}</h3>
        {aside}
      </div>
      {children}
    </section>
  );
}
